var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgExcellence = function SvgExcellence(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#excellence_svg__a)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.117 8.252 12.297.789a1.46 1.46 0 0 0-2.052-.576 1.46 1.46 0 0 0-.535.576L6.885 8.252H1.397a1.34 1.34 0 0 0-1.3.842 1.348 1.348 0 0 0 .356 1.51l4.764 3.327-2.64 6.074a1.444 1.444 0 0 0 1.187 1.988c.299.03.6-.036.86-.186l2.119-1.194a3.468 3.468 0 0 1 2.814-5.61h4.572l2.554-6.751h-1.566Z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.414 8.86 3.077 8.142h5.987a1.464 1.464 0 0 1 1.415.92 1.472 1.472 0 0 1-.382 1.645l-5.197 3.63 2.88 6.627a1.575 1.575 0 0 1-1.294 2.168 1.566 1.566 0 0 1-.94-.203l-6.956-3.92-6.96 3.92a1.565 1.565 0 0 1-2.313-1.006 1.576 1.576 0 0 1 .08-.959l2.88-6.627-5.197-3.63a1.468 1.468 0 0 1 1.03-2.565h5.987l3.08-8.142a1.592 1.592 0 0 1 2.237-.628c.25.152.451.37.585.628Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "excellence_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
};
export default SvgExcellence;